import { render, staticRenderFns } from "./tela_info_abertura.vue?vue&type=template&id=e00e2244&"
import script from "./tela_info_abertura.vue?vue&type=script&lang=js&"
export * from "./tela_info_abertura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports